import React from 'react';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { validateInput } from '../../data/providerText';
import axios from '../../../shared/axios/axiosProxy';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import classes from '../providerEntry.module.scss';
import { legalDocuments } from '../../../shared/data/legalDocuments';
import dash from '../../../images/icon-dash.svg';
import notmet from '../../../images/icon-notmet.svg';
import met from '../../../images/icon-met.svg';

import telekom from '../../../images/telekom.svg';
import mbh from '../../../images/mbh.svg';
import perfekt from '../../../images/perfekt.svg';
import headset from '../../../images/icon-headset.svg';
import warning from '../../../images/icon-warning.svg';
import envelop from '../../../images/icon-envelop.svg';

class RegistryInputs extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			password: '',
			passwordError: '',
			emailError: '',
			accountCreated: false,
			showPassword: false,
			gdpr: false,
			gdprError: '',
			uppercaseError: false,
			lowercaseError: false,
			lengthError: false,
			numberError: false,
		};
	}

	registerProvider = async () => {
		const { password, email } = this.state;
		await axios
			.post('/api/auth/register/provider', {
				email,
				password,
			})
			.then((response) => {
				console.log('AXIOS RESPONSE: ', response.data);
				this.setState({ accountCreated: true });
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
				if (error.response.data) {
					if (error.response.data === 'email already taken') {
						this.setState({
							emailError:
								error.response.data === 'email already taken'
									? i18n.t('provider.alreadyregistered')
									: '',
						});
					}
				}
			});
	};
	handleChange = (event) => {
		if (this.state[`${event.target.id}Error`].length > 0) {
			this.setState({
				[`${event.target.id}Error`]: validateInput(
					event.target.id,
					event.target.value
				)[event.target.id],
			});
			this.setState({
				uppercaseError: validateInput('password', event.target.value).uppercase,
			});
			this.setState({
				lowercaseError: validateInput('password', event.target.value).lowercase,
			});
			this.setState({
				lengthError: validateInput('password', event.target.value).length,
			});
			this.setState({
				numberError: validateInput('password', event.target.value).number,
			});
		}
		this.setState({ [event.target.id]: event.target.value });
	};

	handleBlur = (event) => {
		if (event.target.id === 'password') {
			this.setState({
				passwordError: validateInput('password', event.target.value).password,
			});
			this.setState({
				uppercaseError: validateInput('password', event.target.value).uppercase,
			});
			this.setState({
				lowercaseError: validateInput('password', event.target.value).lowercase,
			});
			this.setState({
				lengthError: validateInput('password', event.target.value).length,
			});
			this.setState({
				numberError: validateInput('password', event.target.value).number,
			});
		}
		if (event.target.id === 'email') {
			this.setState({
				emailError: validateInput('email', event.target.value).email,
			});
		}
	};

	render() {
		return (
			<>
				{this.state.accountCreated ? (
					<div className={classes.EntryFields}>
						<div>
							<div
								className={classes.EntryFieldsBox}
								style={{ minHeight: '400px', height: 'fit-content' }}>
								<img src={envelop} alt='envelop' />
								<p className={classes.EntryTitle} style={{ marginTop: '24px' }}>
									{i18n.t('general.activationlink')}
								</p>
								<span span className={classes.MediumText}>
									{i18n.t('general.activationconfirmation1')}
								</span>
								<span className={classes.Blue14} style={{ background: 'none' }}>
									{this.state.email}
								</span>
								<span className={classes.MediumText}>
									{' '}
									{i18n.t('general.activationconfirmation2')}
								</span>

								<div
									className={classes.EntrySecondaryButton}
									style={{ marginTop: '44px' }}>
									<a className={classes.noDecoration} href='/'>
										{i18n.t('general.backtologin')}
									</a>
								</div>
							</div>
						</div>
						<div className={classes.EntryIssueContact}>
							<img src={headset} alt='headset' />
							<span
								className={classes.SmallText}
								style={{ textDecorationLine: 'none' }}>
								{i18n.t('general.isthereaproblem')}
							</span>
							<span
								className={classes.Blue12}
								style={{ textDecorationLine: 'none' }}>
								<a
									className={classes.noDecoration}
									href='https://ro.bookkeepie.com/contact-bookkeepie'
									target='_blank'
									rel='noreferrer'>
									{i18n.t('general.contactus')}
								</a>
							</span>
						</div>
						<div className={classes.EntryPartners}>
							<img src={telekom} alt='telekom partner' />
							<img src={mbh} alt='mbh partner' />
							<img src={perfekt} alt='perfekt partner' />
						</div>
					</div>
				) : (
					<div className={classes.EntryFields}>
						<div
							className={classes.EntryFieldsBox}
							style={{ minHeight: '534px', height: 'fit-content' }}>
							<p className={classes.Blue10}>{i18n.t('general.forproviders')}</p>
							<p className={classes.EntryTitle}>
								{i18n.t('general.createaccount')}
							</p>
							<p className={classes.MediumText}>
								{i18n.t('general.createaccountsub')}
							</p>
							<div className={classes.providerLoginPaper}>
								<p
									style={{
										margintTop: '16px !important',
										marginBottom: '4px',
										fontSize: '14px',
										fontWeight: '500',
									}}>
									{`${i18n.t('general.emailaddress')} *`}
								</p>
								<TextField
									className={classes.EntryInput}
									id='email'
									type='email'
									name='email'
									value={this.state.email}
									//label={i18n.t('general.emaillabel')}
									onChange={(event) => {
										this.handleChange(event);
									}}
									onBlur={(event) => {
										this.handleBlur(event);
									}}
									error={this.state.emailError}
									sx={{
										'& .MuiOutlinedInput-root': {
											borderRadius: '8px',
										},
									}}
								/>
								<br />
								{this.state.emailError && (
									<p className={classes.ErrorText}>
										<img src={warning} alt='warning triangle' />{' '}
										{this.state.emailError}
									</p>
								)}
								<p
									style={{
										margintTop: '12px !important',
										marginBottom: '4px',
										fontSize: '14px',
										fontWeight: '500',
									}}>
									{`${i18n.t('general.password')} *`}
								</p>
								<TextField
									className={classes.EntryInput}
									id='password'
									autoComplete='new-password'
									type={this.state.showPassword ? 'text' : 'password'}
									name='password'
									//label={i18n.t('general.password')}
									value={this.state.password}
									onChange={(event) => {
										this.handleChange(event);
									}}
									onBlur={(event) => {
										this.handleBlur(event);
									}}
									error={this.state.passwordError ? true : false}
									InputProps={{
										endAdornment: (
											<InputAdornment position='end' tabIndex='-1'>
												<IconButton
													aria-label='toggle password visibility'
													onClick={() =>
														this.setState({
															showPassword: !this.state.showPassword,
														})
													}
													size='large'>
													{this.state.showPassword ? (
														<Visibility />
													) : (
														<VisibilityOff />
													)}
												</IconButton>
											</InputAdornment>
										),
									}}
									sx={{
										'& .MuiOutlinedInput-root': {
											borderRadius: '8px',
										},
									}}
								/>
								{/* {this.state.passwordError && (
									<span className={classes.ErrorText}>
										<img src={warning} alt='warning triangle' />{' '}
										{this.state.passwordError}
									</span>
								)} */}
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '3px',
										margin: '8px 0px',
									}}>
									<img
										style={{ width: '12px' }}
										src={
											this.state.password.length < 1
												? dash
												: !this.state.lengthError
												? met
												: notmet
										}
										alt='dash'
									/>
									<span className={classes.SmallText}>
										{`${i18n.t('general.minimum')} 8 ${i18n.t(
											'general.character'
										)}`}
									</span>
								</div>
								<div
									style={{ display: 'flex', alignItems: 'center', gap: '3px', margin: '8px 0px' }}>
									<img
										style={{ width: '12px' }}
										src={
											this.state.password.length < 1
												? dash
												: !this.state.uppercaseError
												? met
												: notmet
										}
										alt='dash'
									/>
									<span className={classes.SmallText}>
										{`${i18n.t('general.minimum')} 1 ${i18n.t(
											'general.uppercase'
										)}`}
									</span>
								</div>
								<div
									style={{ display: 'flex', alignItems: 'center', gap: '3px', margin: '8px 0px' }}>
									<img
										style={{ width: '12px' }}
										src={
											this.state.password.length < 1
												? dash
												: !this.state.numberError
												? met
												: notmet
										}
										alt='dash'
									/>
									<span className={classes.SmallText}>
										{`${i18n.t('general.minimum')} 1 ${i18n.t(
											'general.number'
										)}`}
									</span>
								</div>
								<FormControlLabel
									style={{
										textAlign: 'left',
										textDecoration: 'none',
									}}
									control={
										<Checkbox
											id='gdpr'
											name='gdpr'
											checked={this.state.gdpr}
											onChange={(event) => {
												if (
													this.state.gdprError.length > 0 &&
													event.target.checked
												) {
													this.setState({
														gdprError: '',
													});
												}
												this.setState({ gdpr: event.target.checked });
											}}
											color='primary'
										/>
									}
									label={
										<span
											className={classes.SmallText}
											style={{ textDecoration: 'none' }}>
											{i18n.t('general.gdpr1')}
											<a
												className='GDPRLink'
												target='_blank'
												rel='noreferrer'
												href={legalDocuments.gdpr}
												id='gdpr'>
												{' '}
												{i18n.t('general.gdpr2')}{' '}
											</a>
											{i18n.t('general.and')}
											<a
												className='GDPRLink'
												target='_blank'
												rel='noreferrer'
												href={legalDocuments.aszf}
												id='aszf'>
												{i18n.t('general.gdpr3')}{' '}
											</a>
										</span>
									}
								/>
								{this.state.gdprError && (
									<p className={classes.ErrorText}>
										<img src={warning} alt='warning triangle' />{' '}
										{this.state.gdprError}
									</p>
								)}
								<div className=''>
									<button
										className={classes.EntryButton}
										onClick={() => {
											if (this.state.gdpr) {
												if (
													this.state.passwordError.length === 0 &&
													this.state.emailError.length === 0
												) {
													this.registerProvider();
												}
											} else if (!this.state.gdpr) {
												this.setState({
													gdprError: i18n.t('general.gdprerror'),
													emailError: validateInput('email', this.state.email)
														.email,
													passwordError: validateInput(
														'password',
														this.state.password
													).password,
												});
											}
										}}>
										{i18n.t('general.registration')}
									</button>
								</div>
							</div>
						</div>
						<div className={classes.EntryIssueContact}>
							<img src={headset} alt='headset' />
							<span
								className={classes.SmallText}
								style={{ textDecorationLine: 'none' }}>
								{i18n.t('general.isthereaproblem')}
							</span>
							<span className={classes.Blue12}>
								<a
									href='https://ro.bookkeepie.com/contact-bookkeepie'
									target='_blank'
									rel='noreferrer'>
									{i18n.t('general.contactus')}
								</a>
							</span>
						</div>
						<div className={classes.EntryPartners}>
							<img src={telekom} alt='telekom partner' />
							<img src={mbh} alt='mbh partner' />
							<img src={perfekt} alt='perfekt partner' />
						</div>
					</div>
				)}
			</>
		);
	}
}

export default withTranslation()(RegistryInputs);
